import { createFileRoute } from "@tanstack/react-router";
import { ComponentEditPage } from "../../../components/products/ComponentEditPage";
import { requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/components/$componentId/edit")({
  beforeLoad: requireModuleAccess(MODULE_WORKSPACE),
  component: ComponentEditRoute,
});

function ComponentEditRoute() {
  const { componentId } = Route.useParams();
  return <ComponentEditPage componentId={componentId} />;
}
